// extracted by mini-css-extract-plugin
export default {"Loading":"LoadingU1OUU","loading":"LoadingU1OUU"};